export const environment = {
  apiUrl: 'https://api.orion-uslugi.ru/',
  uslugiURL: 'https://orion-uslugi.ru',
  production: true,
};
